module.exports = __webpack_public_path__ + "static/media/glass_usecase1.57d14751.jpg";